import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../esri-loader-util';
import { FilterService } from '../../../services/filter.service';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { BaseComponent } from '../../base.component';
var LayerDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LayerDetailComponent, _super);
    function LayerDetailComponent(_vcr, cdr, layerService, toSqlStringService, filterService) {
        var _this = _super.call(this, _vcr) || this;
        _this.cdr = cdr;
        _this.layerService = layerService;
        _this.toSqlStringService = toSqlStringService;
        _this.filterService = filterService;
        _this.recordCount = null;
        _this.filterRecordCount = null;
        _this.maximumRecordUpdateDate = null;
        _this.simpleQuery = null;
        _this.sqlQuery = null;
        _this.filterService.applyFilter.subscribe(function (esriLayer) {
            if (_this.esriLayer.uid === esriLayer.uid) {
                _this.esriLayer = esriLayer;
                _this.setupLayerDetails();
            }
        });
        return _this;
    }
    Object.defineProperty(LayerDetailComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    LayerDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
                this.setupLayerDetails();
                return [2 /*return*/];
            });
        });
    };
    LayerDetailComponent.prototype.setupLayerDetails = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props, query, rootQuery;
            return tslib_1.__generator(this, function (_a) {
                this.setupRecordCounts(this.esriLayer);
                if (this.esriLayer.mapcoreProps && this.esriLayer.type === 'map-image') {
                    this.simpleQuery = 'None';
                    props = this.esriLayer.mapcoreProps;
                    query = props.query;
                    if (query) {
                        if (query.operator) {
                            this.simpleQuery = this.filterService.getSummaryQuery(query, props.columns, props.joinColumns, props.childColumns);
                        }
                    }
                    rootQuery = { operator: 'AND', subqueries: [] };
                    if (props.parentQuery) {
                        rootQuery.subqueries.push(props.parentQuery);
                    }
                    if (query) {
                        rootQuery.subqueries.push(query);
                    }
                    this.sqlQuery = this.toSqlStringService.getSQLFromQuery(rootQuery, props.tables.sort(function (a, b) { return a.geometryType.localeCompare(b.geometryType); })[0], props.columns);
                    this.isReady();
                }
                else {
                    this.isReady();
                }
                return [2 /*return*/];
            });
        });
    };
    LayerDetailComponent.prototype.setupRecordCounts = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props, rootQuery, _a, QueryTask, task, query;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        props = layer.mapcoreProps;
                        this.filterRecordCount = null;
                        this.recordCount = 'Loading...';
                        this.maximumRecordUpdateDate = 'Unknown';
                        if (!(props && layer.type === 'map-image')) return [3 /*break*/, 1];
                        this.filterRecordCount = 'Loading...';
                        rootQuery = { operator: 'AND', subqueries: [] };
                        if (props.parentQuery) {
                            rootQuery.subqueries.push(props.parentQuery);
                        }
                        if (props.query) {
                            rootQuery.subqueries.push(props.query);
                        }
                        this.maximumRecordUpdateDate = 'Loading';
                        this.layerService.getLayerRecordCount(props.parentId, rootQuery).then(function (data) {
                            _this.filterRecordCount = data[0].recordCount;
                            _this.maximumRecordUpdateDate = data[0].maximumRecordUpdateDate;
                            if (!_this.maximumRecordUpdateDate) {
                                _this.maximumRecordUpdateDate = 'Unknown';
                            }
                            _this.cdr.detectChanges();
                        }).catch(function () {
                            _this.filterRecordCount = 'Error';
                            _this.cdr.detectChanges();
                        });
                        this.layerService.getLayerRecordCount(props.parentId).then(function (data) {
                            _this.recordCount = data[0].recordCount;
                            _this.cdr.detectChanges();
                        }).catch(function () {
                            _this.recordCount = 'Error';
                            _this.cdr.detectChanges();
                        });
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(props && props.url)) return [3 /*break*/, 3];
                        this.filterRecordCount = null; // TODO: Allow filtering on feature layer
                        return [4 /*yield*/, Promise.all([ESRI.QueryTask])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), QueryTask = _a[0];
                        task = new QueryTask({ url: props.url });
                        query = layer.createQuery();
                        query.where = '1=1';
                        task.executeForCount(query).then(function (data) {
                            _this.recordCount = data;
                            _this.cdr.detectChanges();
                        }).catch(function () {
                            _this.recordCount = 'Error';
                            _this.cdr.detectChanges();
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        if (layer.type === 'feature') {
                            this.esriLayer.queryFeatureCount().then(function (count) {
                                _this.recordCount = count;
                                _this.cdr.detectChanges();
                            });
                        }
                        else {
                            this.recordCount = 'Unknown';
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return LayerDetailComponent;
}(BaseComponent));
export { LayerDetailComponent };
